export const coresSazonalidade: Cor[] = [
    { nome: "Marrom", hash: "#7D3600" },
    { nome: "Cinza", hash: "#808080" },
    { nome: "Verde", hash: "#1b5e20" },
    { nome: "Azul", hash: "#0000FF" },
    { nome: "Vermelho", hash: "#bb0c0c" },
    { nome: "Amarelo", hash: "#bdaf47" },
    { nome: "Laranja", hash: "#f57f17" },
    { nome: "Roxo", hash: "#800080" },
    { nome: "Preto", hash: "#000000" },
    { nome: "Rosa", hash: "#873070" },
];

type Cor = {
    nome: string;
    hash: string;
};